// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ApplicationTables--next-sr-only--1A0Ysvb","w-full":"ApplicationTables--w-full--g68-22A","programSelector":"ApplicationTables--programSelector--3Na9fQ2"};